<template>
  <div class="order-conform">
    <section class="dialog-content">
      <p>
        Alle bestanden zijn toegevoegd aan uw winkelwagen.
      </p>

      <div class="buttons">
        <button class="pill-button" @click="toCart">
          Verder naar bestellen
        </button>
        <button class="pill-button secondary" @click="addFile">
          Nieuwe bestanden uploaden
        </button>
      </div>
    </section>
  </div>
</template>
<script>
/* import { EventBus, Events } from '@/eventbus/EventBus'
import FolderTreeBrowser from '@/features/filestore/dialogs/FolderTreeBrowser.vue'
import { findOrCreateMyFilesFolder } from '@/features/filestore/FileStoreService.js' */

export default {
  props: [],
  data() {
    return {}
  },
  methods: {
    addFile() {
      document.getElementById('product-order-upload-btn').click()
      this.$emit('close')
    },
    toCart() {
      this.$emit('close')
      this.$router.push({ name: 'checkOut' })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  p {
    text-align: center;
  }
}
.buttons {
  button {
    //width: 180px;
    text-transform: none;
    font-size: 0.82rem;
    display: block;
    margin: 15px auto 0;
  }
}
</style>
